// Guard único de "tour ativo", compartilhado entre o tour genérico (useTour)
// e os tours especializados (UserInfo, Serviço, Nota). Garante que apenas um
// tour rode por vez, evitando dois tours sobrepostos ao trocar de tela.
let active = false;

// Função para encerrar o tour atualmente ativo (destrói o overlay do driver.js).
// O overlay vive no <body> e não é controlado pelo Vue Router, então precisamos
// encerrá-lo manualmente ao navegar — senão ele "vaza" para a próxima tela
// (ex.: token expira, usuário é jogado para /login e o tour continua na tela).
let stopFn: (() => void) | null = null;

export function isTourActive(): boolean {
  return active;
}

export function setTourActive(value: boolean): void {
  active = value;
}

/** Registra como encerrar o tour ativo (ou limpa, passando null). */
export function registerTourStop(fn: (() => void) | null): void {
  stopFn = fn;
}

/** Encerra o tour ativo, se houver. Idempotente. */
export function stopActiveTour(): void {
  const fn = stopFn;
  stopFn = null;
  if (fn) fn();
}
